module.exports = __webpack_public_path__ + "images/marketing/features/auto2.png";